import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import { UserGroupOutlineIcon } from '@mr-yum/frontend-ui'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useLoggerLegacy } from '@/hooks/useLogger'
import { routes } from '@/lib/routes'

import { ActionBlockItem } from './ActionBlockItem'

interface Props {
  venueSlug: string
  count: number
}

export const StartTabBlock = ({ venueSlug, count }: Props) => {
  const intl = useIntl()
  const { logEventLegacy } = useLoggerLegacy()

  return (
    <RouteLink route={routes.socialTabStart} pathData={{ venueSlug }}>
      <ActionBlockItem
        count={count}
        icon={<UserGroupOutlineIcon />}
        onClick={() =>
          logEventLegacy('Clicked on start a tab on venue landing page')
        }
        aria-label={intl.formatMessage({
          defaultMessage: 'Start group order',
          id: 'w9prxu',
        })}
        heading={
          <FormattedMessage defaultMessage="Start group order" id="w9prxu" />
        }
      />
    </RouteLink>
  )
}
